'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Set as ImmutableSet } from 'immutable';
import { UndoIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { useHasReportingCreateAndOwnAccess } from 'reporting-action-components/access/scopes/hooks/useHasScope';
import { trackEvent, EVENTS, ReportingTracker } from '../../lib/usageTracker';
import { RESTORE_REPORT_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
import { getRestorableReports, getReportCounts } from '../../actions/reportsActions';
import { selectedRowsActions } from '../../redux/selectedRows';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useHandleRestore = ({
  selectedRows
}) => {
  const showDialog = useShowDialog();
  const dispatch = useDispatch();
  return () => {
    showDialog({
      dialogType: RESTORE_REPORT_DIALOG,
      dialogProps: {
        appUsageTracker: ReportingTracker,
        reports: selectedRows,
        onRestoreReportSuccess: () => {
          dispatch(selectedRowsActions.clearSelectedRows());
          dispatch(getReportCounts());
          dispatch(getRestorableReports());
        }
      }
    });
  };
};
const BulkRestoreAction = props => {
  const {
    selectedRows
  } = props;
  const hasReportingCreateAndOwnAccess = useHasReportingCreateAndOwnAccess();
  const handleRestore = useHandleRestore({
    selectedRows
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: hasReportingCreateAndOwnAccess,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.restore.table.header.restoreAction.disabledTooltip"
    }),
    children: /*#__PURE__*/_jsx(Link, {
      onClick: () => {
        trackEvent(EVENTS.clickRestoreAsset, {
          action: 'restore',
          actionType: 'create',
          assetType: 'report'
        });
        handleRestore();
      },
      "data-test-id": "restore-bulk-action",
      disabled: !hasReportingCreateAndOwnAccess,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: 200,
        children: [/*#__PURE__*/_jsx(UndoIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.restore.table.header.restoreAction.label"
        })]
      })
    })
  });
};
BulkRestoreAction.propTypes = {
  selectedRows: PropTypes.instanceOf(ImmutableSet).isRequired
};
export default BulkRestoreAction;